/* DoxNetwork · tema Shopify · JS propio. Vanilla, sin librerías.
   Un init por componente; cada uno sale si su elemento no está. */
(function () {
  'use strict';

  function initReveals() {
    var nodos = document.querySelectorAll('.dn-reveal');
    if (!nodos.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodos.forEach(function (n) { n.classList.add('dn-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dn-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodos.forEach(function (n) { io.observe(n); });
  }

  /* Galería de producto: miniaturas → imagen grande. */
  function initGaleria() {
    document.querySelectorAll('[data-dn-galeria]').forEach(function (g) {
      var grande = g.querySelector('[data-dn-grande]');
      var minis = g.querySelectorAll('[data-dn-mini]');
      if (!grande || !minis.length) return;
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          grande.src = m.getAttribute('data-dn-src');
          grande.alt = m.getAttribute('data-dn-alt') || '';
          minis.forEach(function (o) { o.classList.remove('activa'); });
          m.classList.add('activa');
        });
      });
    });
  }

  /* Variantes: al cambiar una opción, localiza la variante y actualiza
     id, precio y disponibilidad. Los datos vienen en un <script type="application/json">. */
  function initVariantes() {
    document.querySelectorAll('[data-dn-producto]').forEach(function (raiz) {
      var datos = raiz.querySelector('[data-dn-variantes]');
      var form = raiz.querySelector('form[data-dn-form]');
      if (!datos || !form) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var inputId = form.querySelector('input[name="id"]');
      var boton = form.querySelector('[data-dn-comprar]');
      var precio = raiz.querySelector('[data-dn-precio]');
      var textoBoton = boton ? boton.getAttribute('data-dn-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-dn-agotado') : '';
      var moneda = raiz.getAttribute('data-dn-moneda') || '$';

      function formatear(centavos) {
        var n = Math.round(centavos / 100);
        return moneda + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      function seleccion() {
        return Array.prototype.map.call(raiz.querySelectorAll('[data-dn-opcion]'), function (o) {
          var m = o.querySelector('input:checked');
          return m ? m.value : null;
        });
      }
      function actualizar() {
        var sel = seleccion();
        var v = variantes.find(function (x) { return x.options.every(function (val, i) { return val === sel[i]; }); });
        if (!v) { if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; } return; }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = formatear(v.price);
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
        var img = raiz.querySelector('[data-dn-grande]');
        if (img && v.featured_image && v.featured_image.src) { img.src = v.featured_image.src; }
        try {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* nada */ }
      }
      raiz.querySelectorAll('[data-dn-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initGaleria();
    initVariantes();
  });
})();
